export default __webpack_public_path__ + "static/furnatura-0a6611733a14b1444b06245b1d856cde.jpg";